import StarIcon from "@mui/icons-material/StarRate";
import { Box, Paper } from "@mui/material";
import { isEmpty, sortBy } from "lodash";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { getColorArea } from "../area/areaHelper";
import { useQueryLocationAutocomplete } from "../hints/LocationAutocomplete";
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton";
import { LocationDto } from "../locations/LocationDtos";

const LocationItemTracker = () => {

    let { data: locations } = useQueryLocationAutocomplete();

    let isMultiworld = useSelector((state: AppState) => state.ui.ootr.main.isMultiworld);
    if (isEmpty(locations))
        return null;

    locations = sortBy(locations, ["areaId"], "asc");
    let width = "630px";
    if (isMultiworld) {
        width = "830px";
    }

    
    return <Box display="flex" flexDirection="column" flexBasis="fit-content" flexWrap="wrap" maxWidth={width}>

        <h2>Location Item Tracking</h2>
        <h3>Overworld</h3>
        <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} flexGrow={1} component={Paper}>
            {locations.filter(x => x.locationType.id === 1).map((loc) => {
               
               return <LocationItemTrackerPlace location={loc}/>
            })}
        </Box>
        <h3>Dungeons</h3>
        <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} flexGrow={1} component={Paper}>
            {locations.filter(x => x.locationType.id === 2).map((loc) => {
               
               return <LocationItemTrackerPlace location={loc}/>
            })}
        </Box>
    </Box>
}

export default LocationItemTracker



const LocationItemTrackerPlace = (props: {location: LocationDto}) => {

    let {location: loc} = props;
    let barrens = useSelector((state: AppState) => state.ui.ootr.main.barren)
    let woths = useSelector((state: AppState) => state.ui.ootr.main.goals);
    let isMultiworld = useSelector((state: AppState) => state.ui.ootr.main.isMultiworld);


    let widthColumn = "300px"
    if (isMultiworld) {
        widthColumn = '400px'
    }
    let isBarren = barrens.some(x => x.id === loc.id);

    let goals = Object.values(woths)?.filter(x => x.location?.id === loc.id);

    let isWoth = goals?.length > 0;

    let color = "inherit"

    let areaColor = getColorArea(loc.areaName);
    if (isBarren)
        color = "red"

    return <Box display="flex" flexDirection="row" marginRight={"15px"} width={widthColumn}>
        <Box flexBasis={"fit-content"} display="flex" sx={{
            color: isBarren ? color : areaColor, fontWeight: "bold", fontSize: "18px",
            textDecoration: isBarren ? "line-through" : "inherit", textDecorationColor: "black"
        }} flexGrow={1}>{loc.name}{isWoth && <StarIcon sx={{ color: "gold" }} />}</Box>
        <Box display="flex" flexDirection={"row"}>
            {!isMultiworld && Array.from(Array(5).keys()).map(index => {
                return <OotItemContextMenuButton barren={isBarren} woth={isWoth} />
            })}
            <Box display={"flex"}>
                {isMultiworld && Array.from(Array(4).keys()).map(index => {
                    return <OotItemContextMenuButton barren={isBarren} woth={isWoth} />
                })}
            </Box>
            <Box display={"flex"} marginLeft={"3px"}>
                {isMultiworld && Array.from(Array(2).keys()).map(index => {
                    return <OotItemContextMenuButton barren={isBarren} woth={isWoth} />
                })}
            </Box>
            <Box display={"flex"} marginLeft={"3px"}>
                {isMultiworld && Array.from(Array(2).keys()).map(index => {
                    return <OotItemContextMenuButton barren={isBarren} woth={isWoth} />
                })}
            </Box>

        </Box>
    </Box>
}